// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/metal.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CalculateCuttingRequest, CalculateCuttingResponse, CalculateWeightRequest, CalculateWeightResponse, ConvertPriceRequest, ConvertPriceResponse, CreateMetalCertificateRequest, GetCuttingRatesRequest, GetCuttingRatesResponse, GetMetalSpecRequest, GetSortamentRequest, GetSortamentResponse, ListMetalCertificatesRequest, ListMetalCertificatesResponse, ListMetalSpecsRequest, ListMetalSpecsResponse, MetalCertificate, MetalSpec, SetCuttingRatesRequest, SetCuttingRatesResponse, SetMetalSpecRequest } from "./metal_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.MetalService
 */
export const MetalService = {
  typeName: "omnios.v1.MetalService",
  methods: {
    /**
     * Stateless computation
     *
     * @generated from rpc omnios.v1.MetalService.CalculateWeight
     */
    calculateWeight: {
      name: "CalculateWeight",
      I: CalculateWeightRequest,
      O: CalculateWeightResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.GetSortament
     */
    getSortament: {
      name: "GetSortament",
      I: GetSortamentRequest,
      O: GetSortamentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.ConvertPrice
     */
    convertPrice: {
      name: "ConvertPrice",
      I: ConvertPriceRequest,
      O: ConvertPriceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cutting
     *
     * @generated from rpc omnios.v1.MetalService.CalculateCutting
     */
    calculateCutting: {
      name: "CalculateCutting",
      I: CalculateCuttingRequest,
      O: CalculateCuttingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.GetCuttingRates
     */
    getCuttingRates: {
      name: "GetCuttingRates",
      I: GetCuttingRatesRequest,
      O: GetCuttingRatesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.SetCuttingRates
     */
    setCuttingRates: {
      name: "SetCuttingRates",
      I: SetCuttingRatesRequest,
      O: SetCuttingRatesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Spec CRUD
     *
     * @generated from rpc omnios.v1.MetalService.GetMetalSpec
     */
    getMetalSpec: {
      name: "GetMetalSpec",
      I: GetMetalSpecRequest,
      O: MetalSpec,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.SetMetalSpec
     */
    setMetalSpec: {
      name: "SetMetalSpec",
      I: SetMetalSpecRequest,
      O: MetalSpec,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.ListMetalSpecs
     */
    listMetalSpecs: {
      name: "ListMetalSpecs",
      I: ListMetalSpecsRequest,
      O: ListMetalSpecsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Certificates
     *
     * @generated from rpc omnios.v1.MetalService.CreateMetalCertificate
     */
    createMetalCertificate: {
      name: "CreateMetalCertificate",
      I: CreateMetalCertificateRequest,
      O: MetalCertificate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MetalService.ListMetalCertificates
     */
    listMetalCertificates: {
      name: "ListMetalCertificates",
      I: ListMetalCertificatesRequest,
      O: ListMetalCertificatesResponse,
      kind: MethodKind.Unary,
    },
  }
};

